export const errors = {
  higher: 'The start time is higher than the end one.',
  defined: 'The times are in the time range already registered.',
}